import { isRejectedWithValue } from "@reduxjs/toolkit";
import { createAlert, } from "../features/alert/alerts";
import { ALERT_TYPE_ERROR,ALERT_TYPE_INFO, BASE_URLS, PLATFORM_TYPE, USERTYPE } from "../constants/constants";
import { useLogoutMutation } from "../services/loginservices";
import { useNavigate } from "react-router";
import { parseJwt } from "../components/utilities/utils";
import axios from "axios";
import { getCookie, setCookie } from "../components/utilities/cookieUtils";

let refresh = false;
const rtkQueryErrorLogger = (api) => (next) => (action) => {


  const token = localStorage.getItem("access_token")
    ? parseJwt(localStorage.getItem("access_token"))
    : "";

  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  if (isRejectedWithValue(action)) {
    if(token && action?.payload?.status == 401){
      if(!refresh){
        refresh = true
      keepMeActive()
      }
    }
    else if(action?.payload?.status == 404){
      api.dispatch(
        createAlert({
          //message: action.error.message,
          message: getErrorMessage(action),
          type: ALERT_TYPE_INFO,
          heading: "Info",
        })
      );
    }else{
    api.dispatch(
      createAlert({
        //message: action.error.message,
        message: getErrorMessage(action),
        type: ALERT_TYPE_ERROR,
        heading: "Error",
      })
    );
  }
  }

  return next(action);
};

function keepMeActive(api) {
  if (localStorage.getItem("refreshToken")) {
    axios
      .post(
        BASE_URLS.LOGIN_BASE_URL + "api/v1/authn-sso/refresh",
        {
          applicationName :(localStorage.userrole=="cs"||localStorage.userrole=="ro")?USERTYPE.ETPBMS:
          (localStorage.userrole=="nodal"||localStorage.userrole=="record"||
          localStorage.userrole=="unit")?USERTYPE.SVP:USERTYPE.ERONET,
          refreshToken: localStorage.getItem("refreshToken"),
        },
        {
          withCredentials:true,
          headers: {
            "Content-Type": "application/json",
            "atkn_bnd": localStorage?.atkn_bnd,
      "rtkn_bnd": localStorage?.rtkn_bnd,
      "channelidobo": "ETPBMS",    
      "PLATFORM-TYPE":PLATFORM_TYPE
          },
        }
      )
      .then((result) => {
        if (result && result.data && result.data.access_token) {
          localStorage.setItem("access_token", result.data?.access_token);
          localStorage.setItem("refreshToken", result.data?.refresh_token);
          localStorage.setItem(
            "rtkn_bnd",
            result.data?.rtkn_bnd
          );
          localStorage.setItem(
            "atkn_bnd",
            result.data?.atkn_bnd
          );
          setCookie('REFRESH_SYNC_V1')
          localStorage.setItem("last_seen_refresh_sync_v1",getCookie("REFRESH_SYNC_V1"))
          // window.location.reload()
        } else {
          setTimeout(() => {
            setCookie("XUSRLGLK",'true')
            localStorage.clear();
            window.location = "/login";
          }, 2000);
        }
      })
      .catch((err) => {
        // // logout(api);
        // localStorage.clear();
        // // window.location.replace("https://demoecinet.eci.gov.in/logout?redirect_uri=ETPBMS");
        //  window.location.href = "/";
        setTimeout(() => {
          localStorage.clear();
          setCookie("XUSRLGLK",'true')
          window.location = "/login";
        }, 2000);
      });
  }
}


const logout=()=>{
  axios({
    url: `${BASE_URLS.LOGIN_BASE_URL}api/v1/authn-sso/logout`,
    method: "POST",
    withCredentials:true,
    headers: {
      'Content-Type': 'application/json',
      'applicationName':
      (localStorage.userrole=="cs"||localStorage.userrole=="ro")?USERTYPE.ETPBMS:
      (localStorage.userrole=="nodal"||localStorage.userrole=="record"||
      localStorage.userrole=="unit")?USERTYPE.SVP:USERTYPE.ERONET,            
      'Authorization': 'Bearer ' + localStorage?.access_token,
      'refreshToken': localStorage?.refreshToken,
      "atkn_bnd": localStorage?.atkn_bnd,
      "rtkn_bnd": localStorage?.rtkn_bnd,
      "channelidobo": "ETPBMS",   
      "PLATFORM-TYPE":PLATFORM_TYPE         
      },
  }).then(()=>{
     localStorage.clear()
    //  window.location.replace("https://demoecinet.eci.gov.in/logout?redirect_uri=ETPBMS");
      window.location.href = "/";
  })
}
const getErrorMessage = (action) => {
    return action.payload.status >= 400
    ? action.payload.error === null
      ? "Please Try Again"
      : action.payload.data?.message ||
        action.payload?.error ||
        action.error?.message
    : action.payload.error;
};
export default rtkQueryErrorLogger;
